<template lang="pug">
  div.map-container.navigation-control
    div.toolbar.toolbar--big.toolbar--bordered
      div.line
        h1.title Карта
        form.search
          input(type="search" placeholder="")


    div.new-map
      div.map-route-popup.map-route-popup--success
        div Добавьте адрес на карте
        span.close--small

      div#map.bigmap
      transition(name="fade")
        div.legend.map-routes.no-pad.cuscroll(:class="showRight ? 'open' : 'close'")
          div.head(@click="showRight = !showRight")
            h2.title Изменение маршрута
            div.legend-info
            span.legend__close(v-if="showRight")
            span.legend__open(v-else)

          div.type-group
            div.route-info
              div.route-info-line.flex-col
                label Номер маршрута
                input(value="Маршрут №12" type="text")

          div.type-group
            div.route-info
              div.route-info-line
                label Протяженность (км):
                span 12
              div.route-info-line
                label Приблизительное время (ч):
                span 12

          div.type-group
            div.route-info.schedule
              div.route-info-line
                label Периодичность маршрута

              div.route-info-line.flex
                .route-info-line__block
                  div.periodicity
                    label.radioButton
                      input.radio(type="radio" name="group1" checked)
                      span Ежедневный
                    label.radioButton
                      input.radio(type="radio" name="group1")
                      span Через день
                    label.radioButton
                      input.radio(type="radio" name="group1")
                      span Раз в три дня
                .route-info-line__block
                  div.week
                    p День недели
                    label.radioButton
                      input.radio(type="radio" name="group2" checked)
                      span Пн
                    label.radioButton
                      input.radio(type="radio" name="group2")
                      span Вт
                    label.radioButton
                      input.radio(type="radio" name="group2")
                      span Ср
                  div.week
                    label.radioButton
                      input.radio(type="radio" name="group2" )
                      span Чт
                    label.radioButton
                      input.radio(type="radio" name="group2")
                      span Пт
                    label.radioButton
                      input.radio(type="radio" name="group2")
                      span Сб
                  div.week
                    label.radioButton
                      input.radio(type="radio" name="group2")
                      span Вс

          div.type-group.type-group--small-pad
            div.add-address
              button.actions-panel__button.btn-add.green.small
              span Добавить адрес

          div.type-group.type-group--noborder.route-table
            table
              thead
                th №
                th Адрес
                th Количество конт
                th Объем куб.м.
                th
              tbody
                tr
                  td 1
                  td ул Строителей, 68
                  td 5
                  td 3,75
                  td
                    span.close--small
                tr
                  td 2
                  td Парковая улица, 43
                  td 2
                  td 1,5
                  td
                    span.close--small
                tr
                  td 3
                  td Парковая улица, 19
                  td 5
                  td 3,75
                  td
                    span.close--small
                tr
                  td 4
                  td ул Чехова, 68
                  td 2
                  td 1,5
                  td
                    span.close--small
                tr
                  td 5
                  td ул Чехова, 72А
                  td 1
                  td 0,75
                  td
                    span.close--small
                tr
                  td 6
                  td ул Чкалова, 44А
                  td 3
                  td 2,25
                  td
                    span.close--small
                tr
                  td 7
                  td Красноармейская улица, 41
                  td 5
                  td 3,75
                  td
                    span.close--small
                tr
                  td 8
                  td ул Мира, 71А
                  td 5
                  td 3,75
                  td
                    span.close--small
                tr
                  td 9
                  td ул Шевченко, 25
                  td 5
                  td 3,75
                  td
                    span.close--small


</template>

<script>
  import 'leaflet';

  window.L = L;

  export default {
    data() {
      return {
        showRight: true,
        map: [],
        markers: null
      };
    },
    methods: {
      initmap3() {
        this.map = L.map('map', {
          center: [56.84325131, 60.60611655],
          zoom: 17
        });
        L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {}).addTo(this.map);
      }
    },
    mounted() {
      this.$store.dispatch('initelements');
      this.initmap3();
    }
  };
</script>

<style lang="scss">
  @import "../../../../node_modules/leaflet/dist/leaflet.css";
</style>
